import { ActionNames } from '../action-names';
import { IAppState } from '../models';

export type UpdateMetaTitle = { type: ActionNames.UPDATE_META_TITLE; value: string };
export type UpdateMetaDescription = { type: ActionNames.UPDATE_META_DESCRIPTION; value: string };
export type UpdateMetaPagination = { type: ActionNames.UPDATE_META_PAGINATION; value: { count: number, page: number } };
export type UpdateOgUrl = { type: ActionNames.UPDATE_OG_URL; value: string };
export type UpdateMetaRobots = { type: ActionNames.UPDATE_META_ROBOTS; value: string };

export function metadataActionHandlers(currentState: IAppState, action: UpdateMetaTitle | UpdateMetaDescription | UpdateMetaPagination | UpdateOgUrl | UpdateMetaRobots): IAppState {

    switch (action.type) {
        case ActionNames.UPDATE_META_TITLE: {
            return {
                ...currentState,
                metadata:
                {
                    ...currentState.metadata,
                    ogTitle: action.value,
                    ogTwitterTitle: action.value
                }
            };
        }
        case ActionNames.UPDATE_META_DESCRIPTION: {
            return {
                ...currentState,
                metadata:
                {
                    ...currentState.metadata,
                    ogDescription: action.value
                }
            };
        }
        case ActionNames.UPDATE_META_PAGINATION: {
            return {
                ...currentState,
                metadata:
                {
                    ...currentState.metadata,
                    pagination: action.value
                }
            };
        }
        case ActionNames.UPDATE_OG_URL: {
            return {
                ...currentState,
                metadata:
                {
                    ...currentState.metadata,
                    ogUrl: action.value
                }
            };
        }
        case ActionNames.UPDATE_META_ROBOTS: {
            return {
                ...currentState,
                metadata:
                {
                    ...currentState.metadata,
                    robots: action.value
                }
            };
        }
        default:
            return currentState;
    }
}
